import { formInputStyles } from '../styles';
import { BlueprintFormData } from '../types';
import { applicationTypes } from '../utils/applicationTypes';
import { BlueprintStepSection } from './BlueprintStepSection';
import { ResponsiveFormContainer } from './ResponsiveFormContainer';
import { Typography } from '@mui/material';
import { DatePickerInput } from 'components/inputs/DatePickerInput';
import { TextInput } from 'components/inputs/TextInput';
import { IconToggleButtonGroup } from 'greener-ui-library';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DATE_FORMAT } from 'utils/constants';

interface AboutProjectStepProps {
  formMethods: UseFormReturn<BlueprintFormData>;
  blueprintId?: number;
  mode?: 'create' | 'edit';
}

export const AboutProjectStep = ({ formMethods }: AboutProjectStepProps) => {
  const { t } = useTranslation();
  const { control, trigger, setValue } = formMethods;

  return (
    <>
      <BlueprintStepSection title={t('blueprints:wizard.sections.generalInfo')}>
        <ResponsiveFormContainer>
          <TextInput
            control={control}
            name="blueprintName"
            label={`${t('blueprints:wizard.fields.blueprintName')} *`}
            placeholder={t('blueprints:wizard.fields.blueprintName')}
            sx={formInputStyles}
          />
          <TextInput
            control={control}
            name="clientName"
            label={`${t('blueprints:wizard.fields.clientName')} *`}
            placeholder={t('blueprints:wizard.fields.clientName')}
            sx={formInputStyles}
          />
        </ResponsiveFormContainer>
      </BlueprintStepSection>

      <BlueprintStepSection title={t('blueprints:wizard.fields.applicationType.title')} titleSpacing={24}>
        <IconToggleButtonGroup
          options={applicationTypes.map((type) => ({ ...type, label: t(type.label) }))}
          value={formMethods.watch('applicationType') || ''}
          onChange={(value) => formMethods.setValue('applicationType', value || '')}
        />
      </BlueprintStepSection>

      <BlueprintStepSection title={t('blueprints:wizard.fields.projectDuration.title')} titleSpacing={8}>
        <Typography variant="caption" sx={{ display: 'block', mb: 2, color: 'text.primary' }}>
          {t('blueprints:wizard.fields.projectDuration.helperText')}
        </Typography>
        <ResponsiveFormContainer maxColumnWidth={190} minColumnWidth={190}>
          <DatePickerInput
            control={control}
            name="startDate"
            label={`${t('blueprints:wizard.fields.projectDuration.startDate')} *`}
            showTimeInput={false}
            gridSize={false}
            fullWidth={true}
            size="small"
            dateFormat={DATE_FORMAT}
            initialHours={0}
            initialMinutes={0}
            initialSeconds={0}
            onChange={() => trigger('endDate')}
          />
          <DatePickerInput
            control={control}
            name="endDate"
            label={t('blueprints:wizard.fields.projectDuration.endDate')}
            showTimeInput={false}
            gridSize={false}
            fullWidth={true}
            size="small"
            dateFormat={DATE_FORMAT}
            initialHours={23}
            initialMinutes={59}
            initialSeconds={59}
            placeholder={t('blueprints:wizard.fields.projectDuration.endDatePlaceholder')}
            isClearable
            onChange={({ date }) => {
              if (date === null) {
                setValue('endDate', null as unknown as Date, { shouldValidate: false, shouldDirty: true });
              }
              trigger('endDate');
            }}
          />
        </ResponsiveFormContainer>
      </BlueprintStepSection>
    </>
  );
};
